"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2803 14.5871c2.3713 0 4.2936-1.9223 4.2936-4.2936C17.5739 7.9223 15.6516 6 13.2803 6c-2.3712 0-4.2935 1.9223-4.2935 4.2935 0 2.3713 1.9223 4.2936 4.2935 4.2936zm0 2c1.3771 0 2.6508-.4423 3.6869-1.1925l4.6016 4.6016 1.4142-1.4142-4.6016-4.6016c.7502-1.0361 1.1925-2.3099 1.1925-3.6869C19.5739 6.8177 16.7562 4 13.2803 4c-3.4758 0-6.2935 2.8177-6.2935 6.2935 0 3.4759 2.8177 6.2936 6.2935 6.2936zM7.9673 4.9999a7.5199 7.5199 0 0 0-1.427 2H.9868v-2h6.9806zm-2.0759 4a7.5956 7.5956 0 0 0-.0784 2H.9869v-2h4.9046zm1.549 6a7.4928 7.4928 0 0 1-1.157-2H.9868v2h6.4536z"
  })];
};

exports.default = _default;